import { render, staticRenderFns } from "./NestedData.vue?vue&type=template&id=253e4e0c&scoped=true"
import script from "./NestedData.vue?vue&type=script&lang=js"
export * from "./NestedData.vue?vue&type=script&lang=js"
import style0 from "./NestedData.vue?vue&type=style&index=0&id=253e4e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253e4e0c",
  null
  
)

export default component.exports